<template>
  <b-modal :visible="open" centered lazy @hide="hide" hide-footer>
    <template slot="modal-header">
      <b-container class="text-center w-100 mt-2">
        <h5 class="fa fa-times float-right" @click="hide" />
        <h5 v-if="requestState !== 'finished'">
          {{ $t('MODAL_rateplaylist_title') }}
        </h5>
        <h5 v-else>{{ $t('MODAL_rateplaylist_thanks') }}</h5>
      </b-container>
    </template>

    <!-- View for the User -->
    <div>
      <b-row v-if="requestState === 'finished'">
        <b-col class="text-center">
          <p>{{ $t('MODAL_rateplaylist_text') }}</p>
          <b-button-group class="w-100 mt-5">
            <b-button class="w-100" variant="primary" @click="hide">
              {{ $t('MODAL_rateplaylist_close') }}
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>

      <b-form v-else @submit.prevent="rate">
        <div v-if="user">
          <b-row class="mt-2">
            <b-col class="text-center text-secondary">
              <p>{{ $t('MODAL_rateplaylist_closing') }}</p>
            </b-col>
          </b-row>
          <b-row class="my-4">
            <b-col class="d-flex justify-content-center">
              <fa-rating
                :glyph="glyph"
                :increment="1"
                :spacing="8"
                active-color="#a0c64d"
                inactive-color="#ebf3db"
                border-color="#627c28"
                :border-width="3"
                :item-size="40"
                :show-rating="false"
                v-model="stars"
              ></fa-rating>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col>
              <b-form-textarea
                id="feedback"
                v-model="feedback"
                :placeholder="$t('MODAL_rateplaylist_feedback_placeholder')"
                :rows="4"
                :max-rows="6"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="mt-3">
              <b-button-group class="w-100">
                <b-button
                  :disabled="requestState === 'loading' || !stars"
                  type="submit"
                  variant="primary"
                  class="w-100"
                >
                  <span v-if="requestState === 'loading'">
                    <loader />
                  </span>
                  <span v-else>{{
                    $t('MODAL_rateplaylist_send_feedback')
                  }}</span>
                </b-button>
                <b-button
                  :disabled="requestState === 'loading'"
                  @click="hide"
                  variant="secondary"
                >
                  <span>{{ $t('MODAL_rateplaylist_abort') }}</span>
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </div>

        <div v-else class="row">
          <div class="col">
            <b-button
              variant="primary"
              class="w-100 mt-3"
              @click.prevent="login"
              >{{ $t('MODAL_rateplaylist_back_to_login') }}</b-button
            >
          </div>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { FaRating } from 'vue-rate-it';
import Star from 'vue-rate-it/glyphs/star';

import Loader from '@/components/Loader';

export default {
  name: 'ratePlaylist',
  components: { Loader, FaRating },
  props: ['open', 'playlist'],
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      ratingTried: false,
      stars: null,
      feedback: '',
      requestState: null,
      glyph: '',
    };
  },
  created() {
    this.glyph = Star;
  },
  methods: {
    login() {
      this.hide();
      this.$store.dispatch('openLoginModal');
    },
    hide() {
      this.$emit('close');
      this.stars = null;
      this.feedback = '';
      this.requestState = null;
    },
    rate() {
      this.ratingTried = true;
      this.requestState = 'loading';

      this.$store
        .dispatch('ratePlaylist', {
          stars: this.stars,
          feedback: this.feedback,
          playlistId: this.playlist.id,
        })
        .then(() => {
          this.requestState = 'finished';
        });
    },
  },
};
</script>

<style lang="scss" scoped>
:global(.custom-control) {
  padding: 0;
  margin: 2px;
}

#feedback {
  font-size: 1rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/RatePlaylist.vue